import { useQuery } from '@tanstack/react-query'
import { trpc } from '../../../utils/trpc'

const REVIEW_URL_STALE_TIME = 5 * 60 * 1000

// NOTE: This hook calls a protectedProcedure endpoint. In unauthenticated contexts
// (e.g. TaskAccessPage with public tokens), the query will fail with UNAUTHORIZED.
// This is acceptable because reviewviewer components are not used in public-token forms.
// If that changes, pass `enabled: false` from the caller or add an auth-awareness parameter.
export const useReviewViewerUrl = (evaluationId: string, segment: string | undefined) => {
	return useQuery({
		...trpc.client.userFiles.getReviewViewerUrl.queryOptions({
			evaluationId,
			segment: segment as 'EmployeeView' | 'CA_Complete' | 'MGR_Complete',
		}),
		enabled: Boolean(segment) && Boolean(evaluationId),
		staleTime: REVIEW_URL_STALE_TIME,
	})
}

export const useReviewViewerUrls = (evaluationId: string, enabled: boolean) => {
	return useQuery({
		...trpc.client.userFiles.listReviewViewerUrls.queryOptions({
			evaluationId,
		}),
		enabled: enabled && Boolean(evaluationId),
		staleTime: REVIEW_URL_STALE_TIME,
	})
}
